import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "_grid _grid-cols-1 _grid-cols-16--m _gap-4 _gap-6--m _pt-4 _pt-6--m" }
const _hoisted_2 = { class: "_flexcol _gap-4 _gap-6--m _col-span-9--m" }
const _hoisted_3 = {
  key: 0,
  class: "_flexcol _gap-4 _gap-6--m _col-span-7--m"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_backer_center_pending_actions_slider = _resolveComponent("backer-center-pending-actions-slider")
  const _component_backer_center_project_recommendations_section = _resolveComponent("backer-center-project-recommendations-section")
  const _component_backer_center_layout = _resolveComponent("backer-center-layout")

  return (_openBlock(), _createBlock(_component_backer_center_layout, {
    title: _ctx.Resources.BackerCenter.SectionYourDashboardHeader,
    "current-view": "dashboard"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_backer_center_pending_actions_slider, {
          class: "_col-span-16--m",
          "data-qa": "section:BackerCenterPendingActionsSlider"
        }),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.mainColumn, (component) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(component), {
              key: component,
              "data-qa": `section:${component}`
            }, null, 8 /* PROPS */, ["data-qa"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        ($options.sideColumn.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.sideColumn, (component) => {
                return (_openBlock(), _createBlock(_resolveDynamicComponent(component), {
                  key: component,
                  "data-qa": `section:${component}`
                }, null, 8 /* PROPS */, ["data-qa"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_backer_center_project_recommendations_section, {
          class: "_col-span-16--m",
          "extra-large-screen-visible-items-count": 4,
          "data-qa": `section:BackerCenterProjectRecommendationsSection`
        })
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title"]))
}